
import { Inject } from "vue-property-decorator"
import { Options, Vue } from "vue-class-component"
@Options({
  name: "collapse-wrapper",
  props: {
    title: String,
    idx: {
      type: [String, Number],
      required: true
    }
  }
})
export default class CollapseWrapper extends Vue {
  @Inject() native!: any
  readonly idx: string | number | null | undefined = undefined

  onClick(evt: any) {
    this.native.active = this.idx
  }
}
